var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 34.5L68 24.5V59.5L58 49.5V57C58 58.3261 57.4732 59.5979 56.5355 60.5355C55.5979 61.4732 54.3261 62 53 62H23C21.6739 62 20.4021 61.4732 19.4645 60.5355C18.5268 59.5979 18 58.3261 18 57V27C18 24.25 20.25 22 23 22H53C54.3261 22 55.5979 22.5268 56.5355 23.4645C57.4732 24.4021 58 25.6739 58 27V34.5ZM38 52C40.6522 52 43.1957 50.9464 45.0711 49.0711C46.9464 47.1957 48 44.6522 48 42C48 39.3478 46.9464 36.8043 45.0711 34.9289C43.1957 33.0536 40.6522 32 38 32C35.3478 32 32.8043 33.0536 30.9289 34.9289C29.0536 36.8043 28 39.3478 28 42C28 44.6522 29.0536 47.1957 30.9289 49.0711C32.8043 50.9464 35.3478 52 38 52ZM38 47C36.6739 47 35.4021 46.4732 34.4645 45.5355C33.5268 44.5979 33 43.3261 33 42C33 40.6739 33.5268 39.4021 34.4645 38.4645C35.4021 37.5268 36.6739 37 38 37C39.3261 37 40.5979 37.5268 41.5355 38.4645C42.4732 39.4021 43 40.6739 43 42C43 43.3261 42.4732 44.5979 41.5355 45.5355C40.5979 46.4732 39.3261 47 38 47Z",
    fill: "#3969C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.adbc80d66b4278f2a075d6254f309650.svg";
export { ForwardRef as ReactComponent };